export enum ProfileStatus {
  Inactive,
  Active,
}

export enum FaceIdRegistrationStatus {
  Pending,
  Registered,
}

export enum ProfileType {
  Employee,
  Guest,
}
